import React, { useState, useEffect } from "react";
import {
  TutorialContainer,
  InnerContainer,
  ImageContainer,
  TextContainer,
  ContentContainer,
  Header,
  DotsContainer,
  Dot,
} from "./ColdStartTutorialStyles";
import gif1 from "../../../assets/TrainingHelp/gifs/R2-drawing.gif";
import gif2 from "../../../assets/TrainingHelp/gifs/R2-dragging-nodes.gif";

const TUTORIALDATA = [
  {
    imgSrc: gif1,
    textArr: [
      "Left click anywhere on the drawing area to add a node",
      "Right click on a node to remove it",
    ],
  },
  {
    imgSrc: gif2,
    textArr: [
      "Left click and drag to move a node",
      "Draw at least three nodes to start detecting patterns",
    ],
  },
];

const TIMEBETWEENSLIDES = 8000;

export default function ColdStartTutorial({ help, setHelp }) {
  // useState hooks
  const [step, setStep] = useState(1);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const nextSlide = () => {
      setVisible(false);
      setTimeout(() => {
        setStep((prev) => (prev + 1) % 2);
        setVisible(true);
      }, 700);

      setTimeout(nextSlide, TIMEBETWEENSLIDES);
    };

    nextSlide();
  }, []);

  return (
    <TutorialContainer>
      <InnerContainer>
        <Header>Tutorial</Header>
        <ContentContainer visible={visible}>
          <ImageContainer>
            <img
              width="300px"
              src={TUTORIALDATA[step].imgSrc}
              alt="Drawing a pattern in R2"
            />
          </ImageContainer>
          <TextContainer>
            {TUTORIALDATA[step].textArr.map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </TextContainer>
        </ContentContainer>
        <DotsContainer>
          <Dot active={step === 0} />
          <Dot active={step === 1} />
        </DotsContainer>
      </InnerContainer>
    </TutorialContainer>
  );
}
